import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-end"
}
const _hoisted_2 = { class: "d-flex justify-content-around" }
const _hoisted_3 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_4 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_5 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_6 = {
  key: 1,
  class: "my-2 form-group"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "day" }
const _hoisted_10 = { class: "dayDetails" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_calendar = _resolveComponent("calendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hideNewBookingButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAppuntamentoModal && _ctx.openAppuntamentoModal(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nuovo appuntamento",
              text: "Nuovo appuntamento"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "cerchioCalendar available" }, null, -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Libero",
            text: "Libero"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "cerchioCalendar prenotato" }, null, -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Prenotato",
            text: "Prenotato"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cerchioCalendar full" }, null, -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Pieno",
            text: "Pieno"
          })
        ])
      ])
    ]),
    (_ctx.professioni.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Seleziona una professione per vedere il calendario",
              text: "Seleziona una professione per vedere il calendario"
            }),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedProfessione) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professioni, (item, i) => {
                return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item.name), 9, _hoisted_7))
              }), 256))
            ], 512), [
              [_vModelSelect, _ctx.selectedProfessione]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedProfessione)
      ? (_openBlock(), _createBlock(_component_calendar, {
          key: 2,
          onChanged: _ctx.getCalendarData,
          "show-navigator": true,
          "show-mode-changer": false,
          class: "month",
          startMode: "month"
        }, {
          default: _withCtx((calData) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calData.days, (day, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["calendarDay calendarDayDashboard", _ctx.getDayClasses(day)]),
                key: i,
                onClick: ($event: any) => (_ctx.checkDate(day.date))
              }, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$filters.date(day.date, "DD")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Liberi:",
                      text: "Liberi:"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.getAvailsOfDate(day)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Prenotazioni:",
                      text: "Prenotazioni:"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.getPrenotazioniOfDate(day)), 1)
                  ])
                ])
              ], 10, _hoisted_8))
            }), 128))
          ]),
          _: 1
        }, 8, ["onChanged"]))
      : _createCommentVNode("", true)
  ], 64))
}